/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row, UncontrolledTooltip } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './tumor-board-occurrence-participant.reducer';

export const TumorBoardOccurrenceParticipantDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const tumorBoardOccurrenceParticipantEntity = useAppSelector(state => state.tumorBoardOccurrenceParticipant.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="tumorBoardOccurrenceParticipantDetailsHeading">
          <Translate contentKey="tinyMedicRestApp.tumorBoardOccurrenceParticipant.detail.title">TumorBoardOccurrenceParticipant</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="tinyMedicRestApp.tumorBoardOccurrenceParticipant.id">Id</Translate>
            </span>
          </dt>
          <dd>{tumorBoardOccurrenceParticipantEntity.id}</dd>
          <dt>
            <span id="active">
              <Translate contentKey="tinyMedicRestApp.tumorBoardOccurrenceParticipant.active">Active</Translate>
            </span>
            <UncontrolledTooltip target="active">
              <Translate contentKey="tinyMedicRestApp.tumorBoardOccurrenceParticipant.help.active" />
            </UncontrolledTooltip>
          </dt>
          <dd>{tumorBoardOccurrenceParticipantEntity.active ? 'true' : 'false'}</dd>
          <dt>
            <span id="cursor">
              <Translate contentKey="tinyMedicRestApp.tumorBoardOccurrenceParticipant.cursor">Cursor</Translate>
            </span>
            <UncontrolledTooltip target="cursor">
              <Translate contentKey="tinyMedicRestApp.tumorBoardOccurrenceParticipant.help.cursor" />
            </UncontrolledTooltip>
          </dt>
          <dd>{tumorBoardOccurrenceParticipantEntity.cursor}</dd>
          <dt>
            <span id="lastUpdated">
              <Translate contentKey="tinyMedicRestApp.tumorBoardOccurrenceParticipant.lastUpdated">Last Updated</Translate>
            </span>
            <UncontrolledTooltip target="lastUpdated">
              <Translate contentKey="tinyMedicRestApp.tumorBoardOccurrenceParticipant.help.lastUpdated" />
            </UncontrolledTooltip>
          </dt>
          <dd>{tumorBoardOccurrenceParticipantEntity.lastUpdated}</dd>
          <dt>
            <span id="microSec">
              <Translate contentKey="tinyMedicRestApp.tumorBoardOccurrenceParticipant.microSec">Micro Sec</Translate>
            </span>
            <UncontrolledTooltip target="microSec">
              <Translate contentKey="tinyMedicRestApp.tumorBoardOccurrenceParticipant.help.microSec" />
            </UncontrolledTooltip>
          </dt>
          <dd>{tumorBoardOccurrenceParticipantEntity.microSec}</dd>
          <dt>
            <span id="timestampEntry">
              <Translate contentKey="tinyMedicRestApp.tumorBoardOccurrenceParticipant.timestampEntry">Timestamp Entry</Translate>
            </span>
            <UncontrolledTooltip target="timestampEntry">
              <Translate contentKey="tinyMedicRestApp.tumorBoardOccurrenceParticipant.help.timestampEntry" />
            </UncontrolledTooltip>
          </dt>
          <dd>{tumorBoardOccurrenceParticipantEntity.timestampEntry}</dd>
          <dt>
            <span id="invitationStatus">
              <Translate contentKey="tinyMedicRestApp.tumorBoardOccurrenceParticipant.invitationStatus">Invitation Status</Translate>
            </span>
            <UncontrolledTooltip target="invitationStatus">
              <Translate contentKey="tinyMedicRestApp.tumorBoardOccurrenceParticipant.help.invitationStatus" />
            </UncontrolledTooltip>
          </dt>
          <dd>{tumorBoardOccurrenceParticipantEntity.invitationStatus}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.tumorBoardOccurrenceParticipant.participant">Participant</Translate>
          </dt>
          <dd>{tumorBoardOccurrenceParticipantEntity.participant ? tumorBoardOccurrenceParticipantEntity.participant.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.tumorBoardOccurrenceParticipant.occurrence">Occurrence</Translate>
          </dt>
          <dd>{tumorBoardOccurrenceParticipantEntity.occurrence ? tumorBoardOccurrenceParticipantEntity.occurrence.id : ''}</dd>
        </dl>
        <Button tag={Link} to="/tumor-board-occurrence-participant" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button
          tag={Link}
          to={`/tumor-board-occurrence-participant/${tumorBoardOccurrenceParticipantEntity.id}/edit`}
          replace
          color="primary"
        >
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default TumorBoardOccurrenceParticipantDetail;
